export const SCHEMA_VERSION = '0.0.2';
export const SCHEMA_BASE_URL = 'https://axiom.co/ai/schemas/';
export const SCHEMA_URL = `${SCHEMA_BASE_URL}${SCHEMA_VERSION}`;
